class ProductOptions extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.available_variants = []),
      (this.container = this.querySelector(".product-options--container")),
      (this.first_variant = JSON.parse(this.querySelector("[id*=variant-first--json]").innerHTML)),
      (this.inputs = this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]')),
      (this.is_product_page = null !== this.closest(".product-page--root")),
      (this.option_values = []),
      (this.size_chart = this.querySelector(".product-options--option .product-size-chart--root")),
      (this.variants = JSON.parse(this.querySelector("[id*=variant--json]").innerHTML)),
      (this.pfd_variants = JSON.parse(this.querySelector("[id*=pfd-variant--json]").innerHTML)),
      (this.seeMoreColors = this.querySelector(".product-block-options__more-label")), 
      this.getVariantOptions(),
      this.hideOptions(this.first_variant, 0),
      this.disableEmptyOptions(),
      this.optionChangeListener(),
      this.size_chart && this.moveSizeChart();
  }
  disconnectedCallback() {
    this.inputs.off("change.ProductOptions");
  }
  getVariantOptions() {
    if ((this.variants.forEach((t) => t.available && this.available_variants.push(t.options)), 0 < this.available_variants.length))
      for (let i = 0; i < this.available_variants[0].length; i++) this.option_values[i] = [...new Set(this.available_variants.map((t) => t[i]))];
  }
  disableEmptyOptions() {
    const e = this.option_values.flat();
    this.container.querySelectorAll(".radios--input, .disclosure--option").forEach((t) => {
      var i = this.getOptionValue(t);
      e.includes(i) || t.setAttribute("data-empty", !0);
    });
  }
  optionChangeListener() {
    this.inputs.on("change.ProductOptions", ({ target: currentTarget }) => {  

      // Initialize an empty array to store option indices and values
      let optionValues = [];
      // Loop through each item with 'data-item="disclosure"' or checked 'data-item="radio"'
      this.container.querySelectorAll('[data-item="disclosure"], [data-item="radio"]:checked').forEach((item) => {
          // Find the closest parent with class '.product-options--option' and get its 'data-index'
          let optionIndex = item.closest(".product-options--option").dataset.index;
          // Push the index and item value to the optionValues array
          optionValues.push({ index: optionIndex, value: item.value });
      });
      
  
      // Hide options
      this.hideOptions(
          optionValues.map((item) => item.value),
          currentTarget.closest(".product-options--option").index(),
          this.pfd_variants
      );
  
      // Initialize a flag to determine if a matching variant is found
      let matchingVariantFound = false;
      let pfd_available = true;
      
      // Loop through each variant
      this.variants.every((variant) => {

          // Assume current variant matches the selected options
          let doesMatch = true;
  
          // Check if the current variant matches all selected options
          optionValues.forEach((selectedOption) => {
              doesMatch = doesMatch && variant.options[selectedOption.index] === selectedOption.value;
          });
  
          // If the current variant does not match, continue to the next variant
          if (!doesMatch) {
              return true;
          } else {
             // If the current variant matches, update the flag and stop the loop
             // Ensure theme.settings.core_colors is treated as an array and switch to .includes() for checking array contents
              var coreColors = theme.settings.core_colors ? theme.settings.core_colors : [];

              // Cache DOM elements for reuse
              var customColorInput = document.querySelector(".line-item-property__field.custom-color-input");
              var availableColorMessage = document.querySelector(".line-item-property__field.available-color-message");
              var pfdColorMessage = document.querySelector(".line-item-property__field.pfd-color-message");

              if (variant.option1 === "PFD") {
                pfdColorMessage.style.display = "block";
                customColorInput.style.display = "none";
                availableColorMessage.style.display = "none";
              } else if (coreColors.indexOf(variant.option1) != -1) {
                availableColorMessage.style.display = "block";
                customColorInput.style.display = "none";
                pfdColorMessage.style.display = "none";
              } else {
                customColorInput.style.display = "block";
                availableColorMessage.style.display = "none";
                pfdColorMessage.style.display = "none";
              }
              matchingVariantFound = variant;
              return false;
          }
      });

      if (this.pfd_variants) {
        for (var i = 0; i < this.pfd_variants.length; i++) {
            var pfd_variant = this.pfd_variants[i];
            if (pfd_variant.option2 == matchingVariantFound.option2 && !pfd_variant.available) {
                pfd_available = false;
                break; // Exit the loop as soon as an unavailable variant is found
            }
        }
      }
  
      // Update with the found variant
      this.updateVariant(matchingVariantFound, pfd_available);
    });
  }
  updateVariant(t, pfd_available) {
    this.is_product_page && this.updateHistoryState(t.id), window.trigger(`theme:product:${this.dataset.id}:variantChanged`, { variant: t, pfd_available: pfd_available });
  }
  updateHistoryState(t) {
    let i = "" + location.origin + location.pathname;
    t && (i += "?variant=" + t), history.replaceState({ path: i }, "", i);
  }
  hideOptions(a, i) {
    let pfd_available = true;  // Assume availability
    if (this.pfd_variants) {
      for (var i = 0; i < this.pfd_variants.length; i++) {
          var pfd_variant = this.pfd_variants[i];
          if (pfd_variant.option2 == a[i] && !pfd_variant.available) {
              pfd_available = false;
              break;
          }
      }
    }

    const filteredOptions = 
    this.option_values.length === 0
        ? []
        : a.map((currentValue, currentIndex) =>
            this.option_values[currentIndex].filter((option) => {
                const clonedArray = [...a];
                clonedArray[currentIndex] = option;
                return this.available_variants.some(variant => variant.join(",") === clonedArray.join(","));
            })
          );
    this.container.childNodes.forEach((childNode, index) => {
      if (index !== i) {
          childNode.querySelectorAll(".radios--input, .disclosure--option").forEach((element) => {
            var optionValue = this.getOptionValue(element);
            pfd_available = true;
            if (this.pfd_variants) {
              for (var i = 0; i < this.pfd_variants.length; i++) {
                  var pfd_variant = this.pfd_variants[i];
                  if (pfd_variant.option2 == optionValue && !pfd_variant.available) {
                      pfd_available = false;
                      break;
                  }
              }
            }
            if (!pfd_available || filteredOptions.length == 0) {
              element.setAttribute("data-unavailable", true);
            } else {
              element.setAttribute("data-unavailable", !filteredOptions[index].includes(optionValue));
            }
          
          });
      }
    });
  }
  getOptionValue(t) {
    return t.getAttribute("data-value") ? t.getAttribute("data-value") : t.value;
  }
  moveSizeChart() {
    this.size_chart.parentNode.querySelector("label").parentNode.appendChild(this.size_chart), this.size_chart.removeAttribute("style");
  }
}
const productOptionsEl = customElements.get("product-options-root");
productOptionsEl || customElements.define("product-options-root", ProductOptions);
